import { webApi } from '@/shared/api/WebApi';
import type { ISharedLinkCfgJson } from '@lib2/model/link/LinkTypes';

/**
 * API calls for link template retrieval
 */
export class LinkApi {
  /**
   * Get shared link configuration for a customer.
   * Contains URL templates for account, media, parent account, and player files.
   */
  static getSharedLinkConfig(cId: number): Promise<ISharedLinkCfgJson> {
    return webApi.get<ISharedLinkCfgJson>('link/sharedcfg', { cId });
  }
}
